import { useTranslation, withTranslation } from "react-i18next";
import { IMAGE_DNS } from "utils/config/Config";

function NotContent() {
  const { t } = useTranslation();
  return (
    <div className="article img _0 clearfix">
      <div className="cont no-article clearfix">
        <img
          className=""
          src={
            IMAGE_DNS +
            "/Valofe_file/web/vfun-ko/images/community/page/funny-no-article-min.png"
          }
          alt={t("There_are_no_posts")}
        />
        <p>{t("There_are_no_posts")}</p>
        <p>{t("Be_the_first_user_to_leave_a_post")}</p>
      </div>
    </div>
  );
}

export default withTranslation()(NotContent);
